import React, { ReactElement } from 'react';

import { CountriesMap } from './CountriesMapPublic';
import { AppLayoutMapControls } from './MapControls';

export const CountriesOutbreaksPublicMap = (): ReactElement => {
  return <CountriesMap renderMapControls={props => <AppLayoutMapControls {...props} />} />;
};
